import { Modal, Form, message, Input } from 'antd';
import { APPOINTMENT_STATUSES } from 'constants/appointments';
import { useModalStateContext, useUIDispatchContext } from 'providers/UI';
import { FC, memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { rejectAppointment as rejectAppointmentApi } from 'services/api/appointments';

import { useAppointmentDetail } from 'pages/AppointmentsDetails/AppointmentDetailContext';
import { showErrorMessage } from 'utils/showErrorMessage';

const { TextArea } = Input;

const RejectModal: FC = () => {
  // form
  const [form] = Form.useForm();
  // translations
  const { t } = useTranslation();
  // context
  const { rejectAppointment: rejectAppointmentModal } = useModalStateContext();
  const { toggleModal } = useUIDispatchContext();
  const { refresh } = useAppointmentDetail();
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    toggleModal('rejectAppointment', false);
    form.resetFields();
  };

  const onFinish = async (values: { reason: string }) => {
    const id = rejectAppointmentModal.params?.id;
    if (!id) return;

    try {
      setLoading(true);
      await rejectAppointmentApi(id, { reason: values.reason });
      const isCanceled =
        rejectAppointmentModal.params?.status === APPOINTMENT_STATUSES.canceled;

      message.success(
        t(`messages.successfully_${isCanceled ? 'canceled' : 'rejected'}`)
      );
      closeModal();
      refresh();
    } catch (err) {
      showErrorMessage(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={t(
        `appointments_details.${
          rejectAppointmentModal.params?.status ===
          APPOINTMENT_STATUSES.canceled
            ? 'cancel'
            : 'reject'
        }`
      )}
      open={rejectAppointmentModal.visible}
      onOk={form.submit}
      onCancel={closeModal}
      confirmLoading={loading}
    >
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.Item
          label={t('appointments_details.enter_reason')}
          name="reason"
          rules={[{ required: true }]}
        >
          <TextArea style={{ height: 130 }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default memo(RejectModal);
